import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Sticker } from './sticker';
import type { Flavor } from './flavors';

interface EmptyStateProps {
  emoji: string;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  flavor?: Flavor;
  className?: string;
}

/** Friendly nothing-here panel. Keep the copy playful, never apologetic. */
export function EmptyState({
  emoji,
  title,
  body,
  action,
  flavor = 'grape',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-4 rounded-tile border-2 border-dashed border-hairline-strong px-6 py-12 text-center',
        className,
      )}
    >
      <span className="text-5xl" aria-hidden>
        {emoji}
      </span>
      <Sticker flavor={flavor} rotate={-2}>
        {title}
      </Sticker>
      {body && <p className="max-w-xs text-sm text-ink-soft">{body}</p>}
      {action}
    </div>
  );
}
